<script setup lang="ts">
import { RouterView, RouterLink, useRouter, useRoute } from 'vue-router';
import { ref, watch, onMounted } from 'vue';
import { api } from './api';

const router = useRouter();
const route = useRoute();
const isAuthenticated = ref(!!localStorage.getItem('auth_token'));

// Re-check auth state on route changes (localStorage is not reactive)
watch(() => route.path, () => {
  isAuthenticated.value = !!localStorage.getItem('auth_token');
});
const appVersion = __APP_VERSION__;
const serverVersion = ref('');

onMounted(async () => {
  if (isAuthenticated.value) {
    try {
      const health = await api.getHealth();
      serverVersion.value = health.version || '';
    } catch { /* ignore */ }
  }
});

function logout() {
  localStorage.removeItem('auth_token');
  router.push('/login');
}
</script>

<template>
  <div class="min-h-screen">
    <!-- Navigation -->
    <nav v-if="isAuthenticated" class="bg-white shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <img src="/logo-klever.svg" alt="Klever" class="h-8 w-auto" />
            </div>
            <div class="hidden sm:ml-6 sm:flex sm:space-x-8">
              <RouterLink
                to="/"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="$route.path === '/' ? 'border-[#0076b8] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
              >
                Tableau de bord
              </RouterLink>
              <RouterLink
                to="/configs"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="$route.path === '/configs' ? 'border-[#0076b8] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
              >
                Configurations
              </RouterLink>
              <RouterLink
                to="/logs"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="$route.path === '/logs' ? 'border-[#0076b8] text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
              >
                Journaux
              </RouterLink>
            </div>
          </div>
          <div class="flex items-center">
            <button
              @click="logout"
              class="text-sm text-gray-500 hover:text-gray-700"
            >
              Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main content -->
    <main>
      <RouterView />
    </main>

    <!-- Footer -->
    <footer v-if="isAuthenticated" class="fixed bottom-0 right-0 p-2">
      <span class="text-xs text-gray-400">v{{ appVersion }}<template v-if="serverVersion"> | server {{ serverVersion }}</template></span>
    </footer>
  </div>
</template>
